import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import SponsorsUpdateComponent from './component'

export const SponsorsUpdate = combine({
  hooks: [
    withContext(
      'adminSponsorsService',
      ServicesContext,
      ({ adminSponsorsService }) => adminSponsorsService
    ),
    withContext(
      'memberService',
      ServicesContext,
      ({ memberService }) => memberService
    ),
    withContext(
      'preRegistrationService',
      ServicesContext,
      ({ preRegistrationService }) => preRegistrationService
    ),

    withCallbacks(
      {
        getSponsorInfoById:
          ({ adminSponsorsService }) =>
          (sponsorId) => {
            return adminSponsorsService.getSponsorById(sponsorId)
          },
        getLinkForSponsorConfirmSignUp:
          ({ preRegistrationService }) =>
          async (sponsorPreRegistrationId) => {
            return await preRegistrationService.getLinkForBeneConfirmSignUp(
              sponsorPreRegistrationId
            )
          },
        onSubmit:
          ({ adminSponsorsService }, { history }) =>
          async (sponsorDTO) => {
            await adminSponsorsService.updateMember(sponsorDTO)
            toaster.info('Sponsor has been successfully updated')
            history.push(admin.sponsors())
          },
      },
      []
    ),
  ],
  transformProps: ({
    match,
    getSponsorInfoById,
    getLinkForSponsorConfirmSignUp,
    onSubmit,
  }) => {
    return {
      sponsorId: Number(match.params.sponsorId),
      getLinkForSponsorConfirmSignUp,
      getSponsorInfoById,
      onSubmit,
    }
  },
})(SponsorsUpdateComponent)
